let audioCtx = null
let master = null
let timer = null

const getCtx = () => {
  if (!audioCtx) {
    const AC = window.AudioContext || window.webkitAudioContext
    if (!AC) return null
    audioCtx = new AC()
  }
  if (audioCtx.state === 'suspended') audioCtx.resume().catch(() => {})
  return audioCtx
}

const tone = (ctx, out, freq, start, duration, volume) => {
  const osc = ctx.createOscillator()
  const gain = ctx.createGain()

  osc.type = 'sine'
  osc.frequency.value = freq

  gain.gain.setValueAtTime(0.0001, start)
  gain.gain.exponentialRampToValueAtTime(volume, start + 0.03)
  gain.gain.setValueAtTime(volume, start + duration - 0.05)
  gain.gain.exponentialRampToValueAtTime(0.0001, start + duration)

  osc.connect(gain)
  gain.connect(out)
  osc.start(start)
  osc.stop(start + duration + 0.05)
}

const PATTERNS = {
  // Callee: "ding-dong ding-dong" every 3 seconds
  incoming: {
    period: 3000,
    play: (ctx, out, t) => {
      tone(ctx, out, 880, t, 0.3, 0.2)
      tone(ctx, out, 660, t + 0.35, 0.3, 0.2)
      tone(ctx, out, 880, t + 1.0, 0.3, 0.2)
      tone(ctx, out, 660, t + 1.35, 0.3, 0.2)
    },
  },
  // Caller: classic ringback, 1.5s on / 3.5s off
  outgoing: {
    period: 5000,
    play: (ctx, out, t) => {
      tone(ctx, out, 440, t, 1.5, 0.08)
      tone(ctx, out, 480, t, 1.5, 0.08)
    },
  },
}

export const stopRing = () => {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
  if (master) {
    master.disconnect()   // silences anything already scheduled
    master = null
  }
}

export const startRing = (kind) => {
  stopRing()

  const pattern = PATTERNS[kind]
  const ctx = getCtx()
  if (!pattern || !ctx) return

  master = ctx.createGain()
  master.connect(ctx.destination)
  const out = master

  const play = () => pattern.play(ctx, out, ctx.currentTime + 0.05)
  play()
  timer = setInterval(play, pattern.period)
}